import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Divider,
    Stack,
    Flex,
    Text,
    useMultiStyleConfig,
    useBreakpointValue,
} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import PaymentIcons from './payment-icons'
import SocialIcons from '../social-icons'
import BrandLogo from '../icons/logo'
import CountrySelector from '../../components/footer/country-selector'
import LegalLinks from './legal-links'
import ApplicationIcons from './application-icons'

const CopyrightSection = ({data}) => {
    const styles = useMultiStyleConfig('Footer')

    const intl = useIntl()

    const footerData = data?.footer_bottom_group

    const copyrightGroup = footerData?.copyright_group
    const copyright = copyrightGroup?.copyright
    const vatNumber = copyrightGroup?.vat_number

    const breakpoint = useBreakpointValue({
        base: null,
        sm: 'sm',
        lg: 'lg',
    })

    return (
        <>
            {breakpoint === 'lg' && (
                <Box w="100%" {...styles.hideOnMobile}>
                    <Divider {...styles.dividerRule} />
                    <Flex {...styles.paymentsLegal}>
                        <Stack {...styles.countryPayments}>
                            <Flex {...styles.brandCountry}>
                                <BrandLogo
                                    data-testid="brand-logo"
                                    inverted={true}
                                    {...styles.footerBrand}
                                />

                                <CountrySelector intl={intl} />

                                <Text {...styles.copyright} data-testid="copyright">
                                    {`${copyright} ${vatNumber}`}
                                </Text>
                            </Flex>
                            <PaymentIcons
                                data-testid="payment-icons"
                                icons={footerData?.payment_icons}
                            />
                        </Stack>
                        <Stack {...styles.socialAppPrivacy}>
                            <Flex {...styles.socialApp}>
                                <SocialIcons
                                    data-testid="social-icons"
                                    icons={footerData?.social_icons}
                                />

                                <ApplicationIcons icons={footerData?.app_download_icons} />
                            </Flex>
                        </Stack>
                    </Flex>
                </Box>
            )}
            {breakpoint === 'sm' && (
                <Box w="100%" {...styles.hideOnDesktop}>
                    <Stack {...styles.mobileStack} {...styles.mobileContainer}>
                        <SocialIcons data-testid="social-icons" icons={footerData?.social_icons} />
                        <Flex {...styles.mobileLogoCoutry}>
                            <BrandLogo
                                data-testid="brand-logo"
                                inverted={true}
                                {...styles.footerBrand}
                            />
                            <CountrySelector intl={intl} />
                        </Flex>
                        <ApplicationIcons icons={footerData?.app_download_icons} />
                        <PaymentIcons
                            data-testid="payment-icons"
                            icons={footerData?.payment_icons}
                        />
                    </Stack>
                </Box>
            )}
            <Box w="100%" {...styles.copyPositioning}>
                <LegalLinks
                    variant="horizontal"
                    data-testid="legal-links"
                    links={copyrightGroup?.copyright_links}
                >
                    <div id="teconsent"></div>
                </LegalLinks>
                {breakpoint === 'sm' && (
                    <Text data-testid="copyright" {...styles.copyright}>
                        {`${copyright} ${vatNumber}`}
                    </Text>
                )}
            </Box>
        </>
    )
}

CopyrightSection.propTypes = {
    data: PropTypes.shape({
        footer_bottom_group: PropTypes.shape({
            copyright_group: PropTypes.shape({
                copyright: PropTypes.string,
                vat_number: PropTypes.string,
                copyright_links: PropTypes.array,
            }),
            payment_icons: PropTypes.array,
            social_icons: PropTypes.array,
            app_download_icons: PropTypes.array,
        }),
    }),
}

export default CopyrightSection
